import { apiClient } from '@/lib/api/client'
export {
  availabilityStatusColor,
  availabilityStatusLabel,
} from '@/lib/userAvailability'

export interface AssignAgentRow {
  id?: number
  first_name?: string
  last_name?: string
  user_login?: string
  assigned_tickets_count?: number
  active_tickets_count?: number
  availability_status?: string
}

export function assignAgentDisplayName(agent: AssignAgentRow): string {
  return (
    [agent.first_name, agent.last_name].filter(Boolean).join(' ') ||
    agent.user_login ||
    (agent.id != null ? `User #${agent.id}` : 'Agent')
  )
}

export function sortAssignAgents(agents: AssignAgentRow[]): AssignAgentRow[] {
  return [...agents].sort((a, b) =>
    assignAgentDisplayName(a).localeCompare(assignAgentDisplayName(b), undefined, { sensitivity: 'base' })
  )
}

/** Load every page of an assign-agent endpoint, then sort A–Z by display name. */
export async function fetchAllAssignAgents(
  path: string,
  options?: { assignPool?: boolean }
): Promise<AssignAgentRow[]> {
  const perPage = 100
  const all: AssignAgentRow[] = []
  let page = 1
  let lastPage = 1

  do {
    const res = await apiClient.get(path, {
      params: {
        per_page: perPage,
        page,
        order: 'first_name',
        sort: 'asc',
        ...(options?.assignPool ? { assign_pool: 1 } : {}),
      },
    })
    const body = res.data
    const data = Array.isArray(body?.data) ? body.data : Array.isArray(body) ? body : []
    all.push(...data)
    const meta = body?.meta ?? body
    lastPage = Number(meta?.last_page ?? 1) || 1
    page += 1
  } while (page <= lastPage && page <= 50)

  return sortAssignAgents(all)
}
